<template>
  <div class="animated fadeInUp" id="vendors">
    <div class="section">
      <h3 class="text-bold text-center text-md-left text-primary mt-3">
        <svg class="d-inline-block d-md-none" width="62" height="40" viewBox="0 0 62 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.9921 3.03916V0L17.0212 7.0914H24.9921V7.09139H45.2406V3.03916H24.9921Z" fill="#0171ba"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M37.1249 17.5114V20.5506L45.0958 13.4592H37.1249V13.4592L16.875 13.4592V17.5114L37.1249 17.5114Z" fill="#0171ba"/>
        </svg>
         Transactions</h3>
      <h4 class="text-primary text-md-dark text-center text-md-left d-none d-md-block">A history of your transactions</h4>

      <div class="d-flex d-md-none">
        <input type="text" class="form-control rounded-pill" placeholder="Search Transactions" v-model="search">
        <filters-mobile 
          @filtersSubmit="filtersSubmit"
          @reset="clear"
        />
      </div>

      <div class="has-text-centered px-3">
          <div class="has-text-centered">
            <div class="">
              <div class="z-index-2">
                
                <div class="hr-content">
                  <div class="bg-white border-radius-15 pb-50 the-table mt-50">
                    <div class="row mb-20 mt-10 pl-0">
                      <router-link :to="'/customers/request-payment/'" class="w-sm-100 mb-xs-1 mr-sm-1 mr-xs-0">
                        <b-button variant="primary" class="px-5 w-sm-100 md-pill">Request for Payment</b-button>
                      </router-link>
                      <b-button variant="primary" class="px-5 w-sm-100 md-pill" @click="doExport">
                        <b-spinner v-if="loadingExportTransaction" variant="primary" label="Spinning"></b-spinner>
                        <span v-else>Export Transactions</span>
                      </b-button>
                    </div>
                    
                    <!-- start of desktop filters -->
                    <table-filters 
                      @filtersSubmit="filtersSubmit"
                      @reset="clear"
                    />
                    <!-- end of desktop filters -->

                    <div class="row mt-5">
                      <b-tabs active-nav-item-class="nav-active-bottom" class="w-100">
                        <b-tab v-if="loggedInUser.account.is_vendor" :title-link-class="['border-0 px-5 font-weight-bold']" title="Received" @click="status = 'received'" lazy>
                          <transactions-received 
                            :masterTableProps="masterTableProps"
                          />
                        </b-tab>
                        <b-tab v-if="loggedInUser.account.is_payer" :title-link-class="['border-0 px-5 font-weight-bold']" title="Sent" @click="status = 'sent'" lazy>
                          <transactions-sent 
                            :masterTableProps="masterTableProps"
                          />
                        </b-tab>
                      </b-tabs>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
      </div>

    </div>
  </div>
</template>
<script>
import store from '../store';
import { tableMixin } from '../utils/table.mixin';
import spinner from '../utils/Spinner';
import emptyTable from '../utils/empty-table.vue';
import MobileTransaction from '../components/MobileTransaction.vue';
import filtersMobile from '../components/filtersMobile.vue';
import StatusButton from '../components/StatusButton.vue';
import TransactionsSent from '../components/TransactionsSent.vue';
import TransactionsReceived from '../components/TransactionsReceived.vue';
import TableFilters from '../components/TableFilters.vue';
import TransactionAPI from '../api/transactions_api';

export default {
  mixins: [
    tableMixin
  ],
  components: {
    spinner,
    emptyTable,
    MobileTransaction,
    filtersMobile,
    StatusButton,
    TransactionsReceived,
    TransactionsSent,
    TableFilters
  },
  data() {
    return {
      //table_type: 'vendor transaction',
      search: '',
      // dataFromFiltersMobile: {},
      // filter_mobile: {},
      // router_link: '/transactions/',
      loadingExportTransaction: false,
      //authenticated: '',
      loggedInUser: {},
      masterTableProps: {
        fields: [
          {
            key: 'created_at',
            sortable: true,
            label: 'Date'
          },
          {
            key: 'service_type.name',
            sortable: false,
            label: 'Type'
          },
          {
            key: 'service_reference',
            sortable: true,
            label: 'Number'
          },
          {
            key: 'short_id',
            sortable: false,
            label: 'JetpayID'
          },
          {
            key: 'payer_account.name',
            sortable: true,
            label: 'Payer'
          },
          {
            key: 'transaction_amount',
            sortable: false,
            label: 'Amount'
          },
          {
            key: 'status',
            sortable: false,
            label: 'Status'
          },
          {
            key: 'view',
            sortable: false,
            label: 'Details'
          }
        ],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDesc: true,
        sortDirection: 'asc',
        totalRows: 1
      },
      status: 'received',
    };
  },
  props: ['session'],
  beforeMount() {
    this.tokenizer();
    this.getCurrentUser();
  },
  mounted() {
    this.tokenizer();
  },
  computed: {
    filterProperties: {
      get: function () {
        return store.state.filterProperties;
      },
      set: function (newValue) {
        store.state.filterProperties = newValue;
      }
    }
  },
  methods: {
    filtersSubmit (params) {  
      console.log('params', params);
      if (this.status == 'received') {
        TransactionAPI.methods.getPayerReceivedTransactions(params);
      }

      if (this.status == 'sent') {
        TransactionAPI.methods.getPayerSentTransactions(params);
      }
    },
    clear: function() {
      store.dispatch('resetFilterProperties');

      if (this.status == 'received') {
        TransactionAPI.methods.getPayerReceivedTransactions();
      }

      if (this.status == 'sent') {
        TransactionAPI.methods.getPayerSentTransactions();
      }
    },
    doExport () {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      const accountId = userContext.user.account.id;
      const params = this.serialize(this.filterProperties);
      console.log('params', params);
      window.location = 'https://jetpay-api.herokuapp.com/api/v1/payments/export/transactions/' + accountId + '?' + params;
    },
    serialize(obj) {
      var str = [];
      for (var p in obj)
        if (obj.hasOwnProperty(p) && obj[p] && obj[p] != 'null') {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      return str.join("&");
    },
    tokenizer() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
        window.location.href = './login';
      }
    },
    getCurrentUser() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
      } else {
        this.loggedInUser = userContext.user_digest;
      }
    },
    handleRowClick(evt) { 
      // currently unused, might port over
      store.state.currentTransaction = store.getters.getTransactionById(evt.data.id);
      console.log('hmm', store.state.currentTransaction);
      console.log('handleRowClick', evt.data);
    }
  }
};
</script>
<style>
@import '../assets/css/table.css';

body {
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
  color: #444f60;
}
.green-btn {
  color: #0E7D47;
}
.bg-green-success {
  background-color: rgba(11, 175, 134, 0.397);
  outline: none;
}
.bg-red-danger {
  background-color: rgba(165, 34, 16, 0.2);
}
.unclickable-status {
  border: 0;
  cursor: default;
}
.nav-active-bottom {
  border-bottom: 4px solid #00bb5c !important;
}
.row-center td {
  vertical-align: middle !important;
}
/* .bg-none {
  background: none;
} */
/* .modal-content {
  margin: 0;
} */
.close {
  opacity: 1;
  color: white;
  border: 0;
  border-radius: 50%;
  padding: 5px 10px !important;
  margin: 0 !important;
  background-color: #0070ba !important;
}
.modal-backdrop {
  width: 100%;
  height: 100%;
}
.btn-secondary:focus {
  background-color: transparent;
  border-color: transparent !important;
}
.the-pagination ul li,
.tabs li {
  display: inline-block;
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
  .text-md-dark {
    color: black !important;
  }
}
@media (max-width: 767px) {
  .display-sm-none {
    display: none;
  }
  .mr-sm-1 {
    margin-right: 10px;
  }
  .hr-content {
    margin-bottom: 80px;
  }
}
@media (max-width: 478px) {
  .w-sm-100 {
    width: 100%;
  }
  .mb-xs-1 {
    margin-bottom: 10px;
  }
  .mr-xs-0 {
    margin-right: 0px !important;
  }
}
@media (min-width: 478px) {
  .md-pill {
    border-radius: 30px;
  }
}
</style>
